import ProgramCoursePage from '../../../course/program-course-page';
import ProgramPage from '../../../programs/program/program-page';
import SettingsBranchesPage from '../../../settings/classes-and-branches/settings-branches-page';
import HomePage from '../../../home/home.page';
import { LoginPage } from '../../../login/login-page';
import { HighLevelDashboard } from '../../../reports/high-level-report/high-level-dashboard';
import { GeneralAttendance } from '../../../reports/education/general-attendance/general-attendance';
import { ReportDropoutStudents } from '../../../reports/education/dropout-students/report-dropout-students';
import { ReportExams } from '../../../reports/education/exams/report-exams';
import { ReportAssignments } from '../../../reports/education/assignments/report-assignments';
import { ReportLectures } from '../../../reports/education/lectures/report-lectures';
import { ReportCoursesExceedingHour } from '../../../reports/finance/courses-exceeding-hours/report-courses-exceeding-hour';
import { ReportCourseFinancialBetweenBranches } from '../../../reports/finance/course-finanacial-between-branches/report-course-financial-between-branches';
import { CourseFinancialBranchBreakdown } from '../../../reports/finance/course-financial-branch-breakdown/course-financial-branch-breakdown';
import { ProgramFinancialComparisonByBranches } from '../../../reports/finance/program-financial-comparison-by-branches/program-financial-comparison-by-branches';
import { ReportRealEstateComparison } from '../../../reports/finance/real-estate-comparison/report-real-estate-comparison';
import { ReportStudentCourseByStatus } from '../../../reports/education/student-courses-by-status/report-student-course-by-status';
import { StudentsFinancialDept } from '../../../reports/finance/students-financial-debt/students-financial-dept';
import { ReportChecks } from '../../../reports/accountant/checks/report-checks';
import { ReportScholarship } from '../../../reports/accountant/scholarships/report-scholarship';
import SettingsEducationPage from '../../../settings/studies/settings-education-page';
import StudentsSettingsPage from '../../../settings/students/students.settings.page';
import { SettingsLecturersPage } from '../../../settings/lecturers/settings-lecturers-page';
import ServicesSettings from '../../../settings/services/services.settings';
import { SettingsTimeManagement } from '../../../settings/time-manager/settings-time-management';
import DocsSettingsPage from '../../../settings/docs/tabs/document-types/docs.settings.page';
import SettingsBranchesTab from '../../../settings/classes-and-branches/branches/settings-branches-tab';
import { CoursesListPage } from '../../../courses-list-page/courses-list-page';
import { SalariesGeneratorPage } from '../../../salaries/salary-generator/salaries-generator-page';
import { SalaryHistory } from '../../../salaries/salary-history/salary-history';
import { SalaryGeneratorFlat } from '../../../salaries/salary-generator-flat/salary-generator-flat';
import { UsersPage } from '../../../users/users-page';
import { UserType } from '../../../../api/types/user/user-type';
import ProgramsPage from '../../../programs/programs-page';
import PaymentsPage from '../../../payments/payments.page';
import StudentsPage from '../../../students/students.page';
import LecturesPage from '../../../lectures/lectures.page';
import React from 'react';
import { Location } from '@remix-run/router';
import { MyLectures } from '../../../../users/professor/pages/my-lectures/my-lectures';
import { MyCourses } from '../../../../users/professor/pages/my-courses/my-courses';
import { MyDocs } from '../../../../users/professor/pages/my-docs/my-docs';
import { MyRates } from '../../../../users/professor/pages/my-rates/my-rates';
import { MySalary } from '../../../../users/professor/pages/my-salary/my-salary';
import { MyAssignments } from '../../../../users/student/pages/my-assignments/my-assignments';
import { MyCoursesStudent } from '../../../../users/student/pages/my-courses/my-courses-student';
import { MyExams } from '../../../../users/student/pages/my-exams/my-exams';
import { MyPrograms } from '../../../../users/student/pages/my-programs/my-programs';
import { MyPayments } from '../../../../users/student/pages/my-payments/my-payments';
import { MyLecturesStudent } from '../../../../users/student/pages/my-lectures/my-lectures-student';
import { MyDocsStudents } from '../../../../users/student/pages/my-docs/my-docs-students';
import { DocsGeneral } from '../../../settings/docs/docs-general';
import { toast } from 'react-toastify';
import { ChangePasswordRequiredPage } from '../../../change-password-required/change-password-required-page';
import { ProfessorPolls } from '../../../settings/professor-polls/professor-polls';
import { MyCourseFeedbacksPolls } from '../../../../users/student/pages/my-course-feedbacks-poll/my-course-feedbacks-polls';
import { ExternalExams } from '../../../external-exams/external-exams';
import { UserPageStudentExternalExams } from '../../../user-page/pages/student/external-exams/user-page-student-external-exams';
import { ProfessorCourseFeedbacks } from '../../../reports/education/professor-course-feedbacks/professor-course-feedbacks';
import { ReportInstallments } from '../../../reports/accountant/installments/report-installments';
import { ReportInstallmentBankTransfer } from '../../../reports/accountant/installment-bank-transfer/report-installment-bank-transfer';
import { ClearanceFeedback } from '../../../clearance/clearance-feedback';
import { DonationPage } from '../../../donations/donation-page';
import { MyLecturesCalendarStudent } from '../../../../users/student/pages/my-lectures-calendar/my-lectures-calendar-student';
import { MyLecturesCalendarProfessor } from '../../../../users/professor/pages/my-lectures-calendar/my-lectures-calendar-professor';
import { AccountsPage } from '../../../../crm/pages/accounts/accounts-page';
import { AccountsPaymentsPage } from '../../../../crm/pages/accounts-payments/accounts-payments-page';
import { ReportCrmChecks } from '../../../reports/accountant/crm-checks/report-crm-checks';
import { CrmPaymentReportPage } from '../../../reports/finance/crm-payments/crm-payment-report-page';
import { SettingsAccountingPage } from '../../../settings/accounting/settings-acconting-page';
import { SettingsPermissionPage } from '../../../settings/permissions/settings-permission-page';
import { AccountingDocumentsPage } from '../../../accountings/accounting-documents/accounting-documents-page';
import { DepositPage } from '../../../accountings/deposit/deposit-page';
import { JournalEntriesPage } from '../../../accountings/journal-entries/journal-entries-page';
import { CreditCardClarencePage } from '../../../reports/finance/credit-card-clarence/credit-card-clarence-page';
import { RatesReport } from '../../../reports/management/rates/rates-report';

export const administrationComponent = (
  location: Location,
  branchId: string | undefined,
  programId: string | undefined,
  courseId: string | undefined,
) => {
  let component;
  if (programId) {
    if (courseId) {
      component = (
        <ProgramCoursePage
          branchId={Number(branchId)}
          programId={Number(programId)}
          courseId={Number(courseId)}
        />
      );
    } else {
      component = <ProgramPage />;
    }
  } else {
    const path = location.pathname.split('?')[0]; // Remove query parameters

    // Building hierarchy routes
    if (path.startsWith('/settings/buildings')) {
      if (path.includes('/classes')) {
        //component = <SettingsBuildingClasses />;
        component = <SettingsBranchesPage />;
      } else {
        //component = <SettingsBuildingsList />;
        component = <SettingsBranchesPage />;
      }
    } else if (path.startsWith('/settings/branch-and-classes')) {
      component = <SettingsBranchesPage />;
    } else {
      // Regular switch case for static routes
      switch (path) {
        case '/home':
          component = <HomePage />;
          break;
        case '/login':
          console.log('navigate: /login');
          component = <LoginPage />;
          break;
        case '/clearance/feedback-page/success':
          component = <ClearanceFeedback isSuccess={true} />;
          break;
        case '/clearance/feedback-page/failure':
          component = <ClearanceFeedback isSuccess={false} />;
          break;
        case '/change-password-required':
          component = <ChangePasswordRequiredPage />;
          break;
        case '/':
          component = <HighLevelDashboard />;
          break;
        case '/reports/education/attendance':
          component = <GeneralAttendance />;
          break;

        case '/reports/education/dropout':
          component = <ReportDropoutStudents />;
          break;

        case '/reports/education/exams':
          component = <ReportExams />;
          break;

        case '/reports/education/assignments':
          component = <ReportAssignments />;
          break;

        case '/reports/education/lectures':
          component = <ReportLectures />;
          break;

        case '/reports/finance/courses-exceeding-hours':
          component = <ReportCoursesExceedingHour />;
          break;

        case '/reports/finance/courses-duration-expanded':
          component = <ReportCourseFinancialBetweenBranches />;
          break;

        case '/reports/finance/course-financial-branch-breakdown':
          component = <CourseFinancialBranchBreakdown />;
          break;

        case '/reports/finance/program-revenue-between-branches':
          component = <ProgramFinancialComparisonByBranches />;
          break;

        case '/reports/finance/real-estate-comparison':
          component = <ReportRealEstateComparison />;
          break;

        case '/reports/education/students-course-status':
          component = <ReportStudentCourseByStatus />;
          break;

        case '/reports/education/teaching-feedback':
          component = <ProfessorCourseFeedbacks />;
          break;

        case '/reports/finance/students-financial':
          component = <StudentsFinancialDept />;
          break;

        case '/reports/finance/crm-payments':
          component = <CrmPaymentReportPage />;
          break;

        case '/reports/management/credit-card-clarence':
          component = <CreditCardClarencePage />;
          break;

        case '/reports/elementary':
          component = <div>elementary</div>;
          break;

        case '/reports/tuition-payments':
          component = <div>tuition-payments</div>;
          break;

        case '/reports/checks':
          component = <ReportChecks />;
          break;
        case '/reports/accountant/crm-checks':
          component = <ReportCrmChecks />;
          break;

        case '/reports/standing-orders':
          component = <ReportInstallments />;
          break;

        case '/reports/bank-transfer-installments':
          component = <ReportInstallmentBankTransfer />;
          break;

        case '/reports/scholarships':
          component = <ReportScholarship />;
          break;

        case '/reports/management/rates':
          component = <RatesReport />;
          break;

        case '/settings/studies':
          component = <SettingsEducationPage />;
          break;
        case '/settings/students':
          component = <StudentsSettingsPage />;
          break;

        case '/settings/lectures':
          component = <SettingsLecturersPage />;
          break;

        case '/settings/users':
          component = <div>page users is comming</div>;
          break;

        case '/settings/operation':
          component = <ServicesSettings />;
          break;

        case '/settings/times':
          component = <SettingsTimeManagement />;
          break;

        case '/settings/professor-feedback':
          component = <ProfessorPolls />;
          break;

        case '/settings/permissions-groups':
          component = <SettingsPermissionPage />;
          break;

        case '/settings/docs':
          component = <DocsGeneral />;
          break;

        case '/settings/branch-and-classes/branches':
          component = <SettingsBranchesTab />;
          break;

        case '/accountant':
          component = <SettingsAccountingPage />;
          break;

        case '/accounting-documents':
          component = <AccountingDocumentsPage />;
          break;

        case '/journal-entries':
          component = <JournalEntriesPage />;
          break;

        case '/accounting/deposit':
          component = <DepositPage />;
          break;

        case '/courses':
          if (programId && courseId) {
            component = (
              <ProgramCoursePage
                branchId={Number(branchId)}
                programId={Number(programId)}
                courseId={Number(courseId)}
              />
            );
          }
          break;

        case '/courses-list':
          component = <CoursesListPage />;
          break;

        case '/accounting/salaries':
          component = <SalariesGeneratorPage />;
          break;

        case '/accounting/salaries/flat':
          component = <SalaryGeneratorFlat />;
          break;

        case '/accounting/salaries/history':
          component = <SalaryHistory />;
          break;

        case '/accounting/donations':
          component = <DonationPage />;
          break;

        case '/users':
          component = <UsersPage />;
          break;

        case '/students':
          component = <UsersPage role={UserType.STUDENT} />;
          break;

        case '/lecturers':
          component = <UsersPage role={UserType.LECTURER} />;
          break;

        case '/administration':
          component = <UsersPage role={UserType.ADMINISTRATION} />;
          break;

        case '/campuses/:branchId/programs/:programId':
          component = <ProgramPage />;
          break;

        case '/programs':
          component = <ProgramsPage />;
          break;

        case '/meetings':
          component = (
            <div style={{ marginTop: '40px', marginRight: '40px' }}>מפגשים</div>
          );
          break;

        case '/exams':
          component = (
            <div style={{ marginTop: '40px', marginRight: '40px' }}>מבחנים</div>
          );
          break;

        case '/feedbacks':
          component = (
            <div style={{ marginTop: '40px', marginRight: '40px' }}>משובים</div>
          );
          break;

        case '/payment-services':
          component = <PaymentsPage />;
          break;

        case '/crm/accounts':
          component = <AccountsPage />;
          break;
        case '/crm/accounts-payments':
          component = <AccountsPaymentsPage />;
          break;

        case '/students2':
          component = <StudentsPage />;
          break;

        case '/education/lectures':
          component = <LecturesPage />;
          break;

        case '/external-exams':
          component = <ExternalExams />;
          break;

        // professor
        case '/professor/lectures':
          component = <MyLectures />;
          break;
        case '/professor/lectures-calendar':
          component = <MyLecturesCalendarProfessor />;
          break;
        case '/professor/courses':
          component = <MyCourses />;
          break;
        case '/professor/documents':
          component = <MyDocs />;
          break;

        case '/professor/teaching-rates':
          component = <MyRates />;
          break;
        case '/professor/salaries':
          component = <MySalary />;
          break;

        // students
        case '/student/programs':
          component = <MyPrograms />;
          break;

        case '/student/courses':
          component = <MyCoursesStudent />;
          break;

        case '/student/lectures':
          component = <MyLecturesStudent />;
          break;

        case '/student/lectures-calendar':
          component = <MyLecturesCalendarStudent />;
          break;

        case '/student/assignments':
          component = <MyAssignments />;
          break;

        case '/student/exams':
          component = <MyExams />;
          break;

        case '/student/documents':
          component = <MyDocsStudents />;
          break;

        case '/student/payment-services':
          component = <MyPayments />;
          break;

        case '/student/course-feedbacks':
          component = <MyCourseFeedbacksPolls />;
          break;

        case '/student/external-exams':
          component = <UserPageStudentExternalExams isStudentMode={true} />;
          break;
        default:
          component = <div>Error page</div>;
          break;
      }
    }
  }

  return component;
};
